module.exports = __webpack_public_path__ + "static/media/mall.a04131c2.svg";